import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { FormikProps } from 'formik';
import { ShopFormValues } from 'components/Types/Tenant/shop.type';

interface Props {
  formik: FormikProps<ShopFormValues>;
}

const ShopSettingsTab: React.FC<Props> = ({ formik }) => {
  return (
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>Shop Name</Label>
          <Input
            type="text"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.name && formik.errors.name)}
          />
          {formik.touched.name && formik.errors.name && (
            <div className="invalid-feedback">{formik.errors.name}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Slug</Label>
          <Input
            type="text"
            name="slug"
            value={formik.values.slug}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.slug && formik.errors.slug)}
          />
          {formik.touched.slug && formik.errors.slug && (
            <div className="invalid-feedback">{formik.errors.slug}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={12}>
        <FormGroup>
          <Label>Description</Label>
          <Input
            type="textarea"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.description && formik.errors.description)}
          />
          {formik.touched.description && formik.errors.description && (
            <div className="invalid-feedback">{formik.errors.description}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="enableNotification"
              checked={formik.values.enableNotification}
              onChange={formik.handleChange}
            />
            Enable Notifications
          </Label>
        </FormGroup>
      </Col>

      {/* show only if enableNotification is true */}
      {formik.values.enableNotification && (
        <Col md={6}>
          <FormGroup>
            {/* <Label for="notificationEmail">Notification Email</Label> */}
            <Input
              type="email"
              id="notificationEmail"
              name="notificationEmail"
              value={formik.values.notificationEmail || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.notificationEmail && formik.errors.notificationEmail)}
              disabled={!formik.values.enableNotification}
              placeholder="Enter notification email"
            />
            {formik.touched.notificationEmail && formik.errors.notificationEmail && (
              <div className="invalid-feedback">{formik.errors.notificationEmail}</div>
            )}
          </FormGroup>
        </Col>
      )}
    </Row>
  );
};

export default ShopSettingsTab;
